import { LeftHandWithProp_Types, LeftHandWithSingleId_Types } from "./consts.js";
export const leftHand_isTypeWithProp = (leftHand) => {
    return LeftHandWithProp_Types.includes(leftHand.type);
};
export const leftHand_isTypeWithSingleId = (leftHand) => {
    return LeftHandWithSingleId_Types.includes(leftHand.type);
};
//# sourceMappingURL=utils.js.map